// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2d6un","checkboxCol":"Table_checkboxCol__3IIGX","emailCol":"Table_emailCol__23wvC","actionCol":"Table_actionCol__2xa7M"};